import { Identity } from './Identity';
import { DOMElement } from '../utils/DOMElement';

/**
 * Password Visibility Component.
 */
export class PasswordVisibility {
  /**
   * Password acc show dom selector.
   *
   * @type {string}
   */
  passwordAccShowClassOne = 'hide-password';

  /**
   * Password acc hide dom selector.
   *
   * @type {string}
   */
  passwordAccHideClassOne = 'show-password';

  /**
   * Constructor of the password visibility.
   */
  constructor() {
    this.isVisible = false;
    this.isPristine = true;

    this.passwordAccHideClass = this.passwordAccHideClassOne;
    this.passwordAccShowClass = this.passwordAccShowClassOne;
    this.passwordInput = document.querySelector(Identity.passwordDOMSelector);
    this.displayTypeButton = document.querySelector(`${Identity.passwordLabelDOMSelector} > button`);
  }

  /**
   * Attach the listener to the password visibility for one.
   */
  attachListenerOne() {
    if (this.displayTypeButton) {
      this.displayTypeButton.addEventListener('click', () => {
        if (DOMElement.hasClass(this.passwordAccShowClass, this.passwordInput) || DOMElement.hasClass(this.passwordAccHideClass, this.passwordInput)) {
          this.showOrHidePassword();
        }
      });
    }
  }

  /**
   * Show or hide the password in the Identity components.
   */
  showOrHidePassword() {
    if (!this.isVisible) {
      this.showPassword();
    } else {
      this.hidePassword();
    }
  }

  /**
   * Show the password in the Identity component.
   */
  showPassword() {
    if (this.passwordInput) {
      this.passwordInput.type = 'text';
      DOMElement.removeClass(this.passwordAccHideClass, this.passwordInput);
      DOMElement.addClass(this.passwordAccShowClass, this.passwordInput);

      DOMElement.removeClass('icon-accessibility-vision', this.displayTypeButton);
      DOMElement.addClass('icon-Hide', this.displayTypeButton);
      this.displayTypeButton.setAttribute('aria-label', 'cacher le mot de passe');

      this.isVisible = true;
    }
  }

  /**
   * Hide the password in the Identity component.
   */
  hidePassword() {
    if (this.passwordInput) {
      const passwordValue = this.passwordInput.value;
      if (passwordValue === '') {
        this.wasShownEmpty = true;
      }
      this.passwordInput.type = 'password';
      DOMElement.removeClass(this.passwordAccShowClass, this.passwordInput);
      DOMElement.addClass(this.passwordAccHideClass, this.passwordInput);

      DOMElement.removeClass('icon-Hide', this.displayTypeButton);
      DOMElement.addClass('icon-accessibility-vision', this.displayTypeButton);
      this.displayTypeButton.setAttribute('aria-label', 'afficher le mot de passe');

      this.isVisible = false;
    }
  }

  /**
   * Clear remember password if the input is empty.
   */
  clearRememberPassword() {
    if (this.wasShownEmpty) {
      this.wasShownEmpty = false;
      this.passwordInput.value = '';
    }
    if (this.isPristine) {
      DOMElement.removeClass('pristine', this.passwordInput);
      this.isPristine = false;
    }
  }
}
